var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _radialGradient, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAnalyticsGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 137.1104463656,
    x2: 203.365985423,
    y1: 373.4819738138,
    y2: 457.8072053414
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb5b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff70ac"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 347.1809240812,
    x2: 231.2336554366,
    y1: 409.9321730054,
    y2: 313.560479831
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#af9ce6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff70ac"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 396.9873015608,
    x2: 531.0041622834,
    y1: 272.4034927346,
    y2: 454.6062000444
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#af9ce6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1591,
    stopColor: "#ab9ce7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3136,
    stopColor: "#9f9be8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4663,
    stopColor: "#8c9beb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6178,
    stopColor: "#709aef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7686,
    stopColor: "#4d99f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9167,
    stopColor: "#2297fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0796ff"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4a72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientTransform: "matrix(0 1.003922 -1.003922 0 -1237.033964 -1453.920176)",
    gradientUnits: "userSpaceOnUse",
    x1: 1898.9861,
    x2: 1935.7094,
    xlinkHref: "#lg1",
    y1: -1487.2018,
    y2: -1487.2018
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 122.5938346378,
    x2: 43.0840153754,
    y1: 505.7821279164,
    y2: 426.272308654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b53759",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb5b0"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 60.6904982348,
    x2: 97.5578270174,
    xlinkHref: "#lg1",
    y1: 256.00011,
    y2: 256.00011
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial0",
    cx: 151.2397449858,
    cy: -51.609120215,
    gradientUnits: "userSpaceOnUse",
    r: 492.958329465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4108,
    stopColor: "#01e5b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5587,
    stopColor: "#04deae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6642,
    stopColor: "#0ad3aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    stopColor: "#13c2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8225,
    stopColor: "#1eac9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8872,
    stopColor: "#2c908f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9442,
    stopColor: "#3b7182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#4e4d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f4a72"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m210.824219 455.78125h-94.371094v-93.292969c0-6.03125 4.890625-10.917969 10.917969-10.917969h72.535156c6.027344 0 10.917969 4.886719 10.917969 10.917969zm0 0",
    fill: "url(#linear0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m351.371094 455.78125h-94.367188v-158.042969c0-6.03125 4.886719-10.917969 10.917969-10.917969h72.53125c6.03125 0 10.917969 4.886719 10.917969 10.917969zm0 0",
    fill: "url(#linear1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m491.921875 455.78125h-94.367187v-233.332031c0-6.03125 4.886718-10.917969 10.914062-10.917969h72.535156c6.03125 0 10.917969 4.886719 10.917969 10.917969zm0 0",
    fill: "url(#linear2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m0 464.816406c0-9.085937 7.363281-16.445312 16.445312-16.445312h479.109376c9.082031 0 16.445312 7.363281 16.445312 16.445312 0 9.082032-7.363281 16.445313-16.445312 16.445313h-479.109376c-9.082031 0-16.445312-7.363281-16.445312-16.445313zm0 0",
    fill: "url(#linear3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m74.144531 481.261719h47.859375l-32.894531-32.894531h-14.964844zm0 0",
    fill: "url(#linear4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m72.992188 512c-9.082032 0-16.445313-7.363281-16.445313-16.445312v-479.109376c0-9.082031 7.363281-16.445312 16.445313-16.445312 9.085937 0 16.445312 7.363281 16.445312 16.445312v479.109376c0 9.082031-7.359375 16.445312-16.445312 16.445312zm0 0",
    fill: "url(#linear5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m483.894531 22.019531-72.941406 39.699219c-12.792969 6.960938-13.328125 25.132812-.964844 32.835938l19.046875 11.875c-25.207031 34.351562-57.332031 64.992187-95.898437 91.382812-40.726563 27.863281-88.6875 51.113281-142.554688 69.09375-22.800781 7.613281-44.761719 13.628906-64.925781 18.375-8.832031 2.078125-15.074219 9.945312-15.074219 19.019531 0 12.601563 11.746094 21.925781 24.007813 19.027344 20.867187-4.929687 43.605468-11.167969 67.351562-19.054687 57.484375-19.101563 108.871094-43.964844 152.734375-73.898438 43.351563-29.585938 79.40625-64.203125 107.582031-103.238281l17.144532 10.6875c12.363281 7.707031 28.441406-.777344 29.058594-15.328125l3.519531-82.96875c.628906-14.773438-15.101563-24.574219-28.085938-17.507813zm0 0",
    fill: "url(#radial0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalyticsGraph);
export default __webpack_public_path__ + "static/media/icon-analytics-graph.33a7cae3757ef43c550882821ce0b7aa.svg";
export { ForwardRef as ReactComponent };